import { useState } from "react"
import { Progress } from "../Progress"
import { Grid } from "./Grid"

export const Panel = ({
  tilte,
  turno,
  confirmationCell,
  animations,
  ratio,
  setRatio,
  ships,
  coords,
  reversed = false,
  isOpponent = false,
  winCallback,
  triggerBomb,
  onClick,
}) => {
  const [hoverCell, setHoverCell] = useState({ x: null, y: null })

  const getHoveredSentence = () => {
    const firstWord = coords.xcoords?.[hoverCell.x]
    const secondWord = coords.ycoords?.[hoverCell.y]

    if (firstWord && secondWord) {
      return `${firstWord} ${secondWord}`
    }

    return "Hover over a cell to read the coordinates"
  }

  return (
    <>
      <div className="col-12">
        <div className="title-container text-center">
          <h4 className={`${turno ? "turno" : ""}`}>{tilte}</h4>
        </div>

        <div className="row px-4">
          <Progress ratio={ratio} />
        </div>

        <div className="row px-4">
          <p className="container-mini container-sm py-2 hovered-sentence">
            {getHoveredSentence()}
          </p>
        </div>
      </div>

      <div className={`row ${reversed ? "reversed" : ""}`}>
        <div className="game-grid-container">
          <div className="x-coord-row pb-3">
            {coords.xcoords.map((col, cix) => (
              <div
                key={cix}
                className={`coord-text coord-text-cols ${
                  hoverCell.x === cix ? "selected-item" : ""
                }`}
              >
                {col}
              </div>
            ))}
          </div>
        </div>
        <div className="y-coord-col" />
      </div>

      <div className={`row ${reversed ? "reversed" : ""}`}>
        <div className="game-grid-container">
          <Grid
            coords={coords}
            confirmationCell={confirmationCell}
            isOpponent={isOpponent}
            animations={animations}
            setRatio={setRatio}
            ships={ships}
            winCallback={winCallback}
            triggerBomb={triggerBomb}
            onClick={onClick}
            setHoverCell={setHoverCell}
          />
        </div>

        <div className="y-coord-col">
          {coords.ycoords.map((row, rix) => (
            <div
              className={`coord-text ${
                hoverCell.y === rix ? "selected-item" : ""
              }`}
              key={rix}
            >
              {row}
            </div>
          ))}
        </div>
      </div>
    </>
  )
}
